import { useEffect } from 'react';
import { useStore } from 'hooks';
import { SocialChannel } from 'store/models/tenantsStore';
import { message } from 'components/ui';

export const useSocials = (phone: string) => {
  const { tenants } = useStore();

  useEffect(() => {
    if (/^\d{10,}$/.test(phone)) {
      tenants.loadSocials(phone);
    }
  }, [phone, tenants]);

  const entry = tenants.getSocialsEntry(phone);

  const toggle = async (channel: SocialChannel) => {
    try {
      await tenants.toggleSocial(phone, channel);
    } catch (error) {
      message({ type: 'error', text: 'Не удалось поменять канал связи' });
    }
  };

  const invalidate = () => {
    tenants.invalidateSocials(phone);
  };

  return { socials: entry, toggle, invalidate };
};
